<!-- https://moservicedesk.atlassian.net/browse/SBE-3 -->
<template>
  <modal
    variant="default"
    custom-class="add-to-calendar"
    no-footer
    aria-labelled-by="modify-calendar-modal-title"
    @close="handleCloseModal"
  >
    <template #default="{ activate }">
      <slot v-bind="{ activate }" />
    </template>

    <template #body="{ deactivate }">
      <div
        v-if="loading"
        class="modal-loading"
      >
        <loading-dots />
      </div>
      <div
        id="modify-calendar-modal-title"
        class="modal-title"
      >
        {{ ModifyReservationCalendarTitle }}
      </div>
      <div class="add-to-calendar-carousel">
        <div
          v-for="(item,index) in currentReservationData.reservations.filter(item => item.status !== 'Cancelled')"
          :key="index"
          class="add-to-calendar-carousel__item"
        >
          <div
            v-if="selectedRes.id === item.id && !loadingRooms"
            class="add-to-calendar-carousel__wrapper"
          >
            <div
              v-if="isMultiRoomReservation"
              class="add-to-calendar-carousel__room"
            >
              <p class="add-to-calendar-carousel__room -name">
                {{ ModifyReservationRoomTitle }} {{ item.roomNumberOrder }}: {{ selectedRes.roomStays[0].roomName }}
              </p>
              <span class="add-to-calendar-carousel__room -confirmation">Confirmation # {{ selectedRes.id }}</span>
            </div>
            <add-to-calendar
              :calendar-event-data="calendarEventData"
              :styles-url="stylesUrl"
            />
            <div class="add-to-calendar-carousel__navigation">
              <button
                v-if="isMultiRoomReservation"
                class="switch -prev"
                :disabled="index === 0"
                @click="arrowClick(index - 1)"
              >
                <em class="icon-chevron-left" />
              </button>
              <button
                v-if="isMultiRoomReservation"
                class="switch -next"
                :disabled="index === RoomsLeft"
                @click="arrowClick(index + 1)"
              >
                <em class="icon-chevron-right" />
              </button>
            </div>
          </div>
        </div>
        <div
          v-if="loadingRooms && isMultiRoomReservation"
          class="add-to-calendar-carousel__loading"
        >
          <loading-dots />
        </div>
      </div>
    </template>
  </modal>
</template>

  <script>
  import { mapState, mapGetters } from 'vuex'
  import { formatDateZone, timeIn12h } from '@utils/date-helpers'
  import addToCalendar from '../../../01.base/add-to-calendar/add-to-calendar.vue'

  export default {
    name: 'ModifyCalendarModal',
    components: {
      addToCalendar
    },
    data: () => ({
      loading: true,
      selectedRes: {},
      loadingRooms: false
    }),
    computed: {
      ...mapState('global', ['lang']),
      ...mapState('modifyReservation', ['currentReservationData', 'modifyBookingPropData']),
      ...mapGetters('modifyReservation', [
        'isMultiRoomReservation',
      ]),
      stylesUrl() {
        const currentUrl = window.location.origin
        const isFractal = currentUrl.includes('localhost:3000')
        if (isFractal) {
          return `${currentUrl}/corporate/corporate/corporate.css`
        }
        return `${currentUrl}/corporate/corporate.css`
      },
      ModifyReservationCalendarTitle() {
        return this.modifyBookingPropData?.ModifyReservationCalendarTitle ? this.modifyBookingPropData?.ModifyReservationCalendarTitle : 'Add your travel dates to your calendar'
      },
      ModifyReservationRoomTitle() {
        return this.modifyBookingPropData?.ModifyReservationRoomTitle ? this.modifyBookingPropData.ModifyReservationRoomTitle : ''
      },
      RoomsLeft() {
        return this.currentReservationData.reservations.filter((item) => item.status !== 'Cancelled').length - 1
      },
      calendarEventData() {
        const eventNameRoom = this.selectedRes.roomStays[0].roomName
        const eventReservationId = this.selectedRes.id
        const eventNameProperty = this.currentReservationData.property.name
        const eventNamePropertyTimeZone = this.currentReservationData.property.propertyTimezone
        const eventStartDate = formatDateZone(this.selectedRes.roomStays[0].startDate, null, 'YYYY-MM-DD')
        const eventEndDate = formatDateZone(this.selectedRes.roomStays[0].endDate, null, 'YYYY-MM-DD')
        const eventLocation = this.currentReservationData.property.city
        const eventPhone = this.currentReservationData.property.phone
        const eventCheckIn = this.currentReservationData.property.checkIn
        const eventCheckInFormatted = timeIn12h(eventCheckIn)
        const eventCheckOut = this.currentReservationData.property.checkOut

        return {
          name: `${eventNameRoom}-${eventNameProperty}`,
          description: this.buildCalendarEventDescription(eventNameProperty, eventCheckInFormatted, eventReservationId, eventPhone),
          startDate: eventStartDate,
          startTime: eventCheckIn,
          endDate: eventEndDate,
          endTime: eventCheckOut,
          timeZone: eventNamePropertyTimeZone,
          location: eventLocation,
          phone: eventPhone
        }
      },
    },
    mounted() {
      this.selectedRes = this.currentReservationData.reservations[0]
      setTimeout(() => {
        this.loading = false
      }, 5000) // needs time to load css bundle url
    },
    methods: {
      arrowClick(index) {
        this.loadingRooms = true
        setTimeout(() => {
          this.selectedRes = this.currentReservationData.reservations[index]
          this.loadingRooms = false
        }, 1000)
      },
      handleCloseModal() {
        // reset current first room on carousel as default
        this.selectedRes = this.currentReservationData.reservations[0]
      },
      buildCalendarEventDescription(hotelName, checkinTime, confirmationNumber, hotelPhone) {
        const calendarEventDescription = this.modifyBookingPropData?.ModifyReservationCalendarDescription
        if (calendarEventDescription !== null || calendarEventDescription !== '') {
          const values = {
            HotelName: hotelName,
            CheckinTime: checkinTime,
            ConfirmationNumber: confirmationNumber,
            HotelPhone: hotelPhone
          }
          return this.updateCalendarEventString(calendarEventDescription, values)
        }
        return ''
      },
      updateCalendarEventString(calendarEventDescription, values) {
        return calendarEventDescription?.replace(/{(\w+)}/g, (placeholder, key) => values[key] || placeholder)
      },
      formatTime(val) {
        return formatDateZone(val, null, 'h:mm A')
      }
    }
  }
  </script>
